module.exports = __webpack_public_path__ + "img/top_icon.3a38d53f.png";